import { getAppChainConfig } from '../utils/network';
import './BridgeEmbedInline.css';

// Superbridge free embed returns 401 (moved to paid model). Use link instead of iframe.
const BRID_GG_BASE = 'https://brid.gg/base';

export default function BridgeEmbedInline({ recipient, onHide, onRefreshBalance }) {
  const chainCfg = getAppChainConfig();
  const toChainId = String(chainCfg.chainId);

  // Prefer REACT_APP_GET_ETH_URL, else Brid.gg for Base (no 401)
  const bridgeBaseUrl = (process.env.REACT_APP_GET_ETH_URL || '').trim()
    || (toChainId === '8453' ? BRID_GG_BASE : toChainId === '84532' ? 'https://testnet.brid.gg/base-sepolia' : 'https://superbridge.app');

  return (
    <div className="bridge-embed-inline">
      <div className="bridge-embed-inline-header">
        <h4 className="bridge-embed-inline-title">Bridge to {chainCfg.chainName}</h4>
        <div className="bridge-embed-inline-header-actions">
          {onRefreshBalance && (
            <button
              type="button"
              className="bridge-embed-inline-refresh"
              onClick={onRefreshBalance}
              aria-label="Refresh balance"
            >
              ↻ Refresh balance
            </button>
          )}
          {onHide && (
            <button
              type="button"
              className="bridge-embed-inline-hide"
              onClick={onHide}
              aria-label="Hide bridge"
            >
              Hide
            </button>
          )}
        </div>
      </div>
      <div className="bridge-embed-inline-wallet-hint">
        <span className="bridge-embed-inline-wallet-hint-icon" aria-hidden>💡</span>
        <span>
          Check your wallet (MetaMask, WalletConnect, etc.) to confirm transactions. You may need to approve the popup manually—look for it in your browser or wallet app.
        </span>
      </div>
      <div className="bridge-embed-inline-body bridge-embed-inline-link">
        <button
          type="button"
          onClick={() => {
            const url = recipient ? `${bridgeBaseUrl}${bridgeBaseUrl.includes('?') ? '&' : '?'}recipient=${encodeURIComponent(recipient)}` : bridgeBaseUrl;
            window.open(url, '_blank', 'noopener,noreferrer');
          }}
          className="bridge-embed-inline-open-btn"
        >
          Open bridge in new tab →
        </button>
        <p className="bridge-embed-inline-hint">
          Bridge ETH from Ethereum to {chainCfg.chainName}. Finished bridging? Use the refresh button above to update your balance.
        </p>
      </div>
    </div>
  );
}
